// @ts-nocheck
import React, { useState, useRef, useLayoutEffect } from "react";
import AssetListItem from "./AssetListItem";
import AssetListItemNEW from "./AssetListItemNEW";
import DataSourceRecord from "./DataSourceRecord";

const ExploreDataSourceList = ({ dataSourceList = {}, onDelete, onRecordClick }) => {
  const [bottomDistance, setBottomDistance] = useState(0);
  const divRef = useRef(null);
  
  useLayoutEffect(() => {
    const calculateBottomDistance = () => {
      const viewportHeight = window.innerHeight;
      const { top } = divRef.current.getBoundingClientRect();
      setBottomDistance(viewportHeight - top);
    };

    calculateBottomDistance();

    // Optional: Recalculate when the window is resized
    window.addEventListener("resize", calculateBottomDistance);

    // Cleanup event listener
    return () => window.removeEventListener("resize", calculateBottomDistance);
  }, []);

  const populateList = () => {
    // Get renderProps for the data source to determine styling (visible/hidden)
    return Object.entries(dataSourceList).map((dataSourceCouple) => {
      const [dataSourceId, dataSource] = dataSourceCouple;
      
      // Check if this data source is visible (to highlight active sources)
      const isVisible = dataSource.renderProps?.visible !== false;

      return <DataSourceRecord 
              key={dataSourceId}
              dataSource={dataSource} 
              isActive={isVisible}
              onClick={()=>onRecordClick(dataSourceId)}
              onDelete={()=>onDelete(dataSourceId)} />
            });
  };

  return (
    <div
      style={{ height: `${bottomDistance}px` }}
      className={`scrollable-div  overflow-y-auto`}
      ref={divRef}
    >
      {populateList()}
    </div>
  );
};

export default ExploreDataSourceList;
